import { Box, Text } from "../cores/index";

const IconColoredNumberOneToFive = (value: { value: string }) => {
  const floatValue = value.value.includes("*")
    ? parseFloat(value.value.split("")[0])
    : parseFloat(value.value);
  return !isNaN(floatValue) ? (
    <Box
      sx={{
        lineHeight: "30px",
        textAlign: "center",
        position: "relative",
        minWidth: "fit-content",
      }}
    >
      <Text
        sx={{
          boxShadow:
            "0px 2px 5px -1px rgb(50 50 93 / 25%), 0px 1px 3px -1px rgb(0 0 0 / 30%)",
          borderRadius: "30px",
          width: "30px",
          height: "30px",
          color: floatValue === 5 ? "white" : "black",
          fontWeight: 600,
          backgroundColor:
            floatValue === 5
              ? "#007AC4"
              : floatValue === 4 || floatValue === 3
              ? "#ECF9FE"
              : floatValue === 2 || floatValue === 1
              ? "#FFFFFF"
              : null,
        }}
      >
        {floatValue}
      </Text>
    </Box>
  ) : (
    <Text as={"p"}>{value.value[1]}</Text>
  );
};

export default IconColoredNumberOneToFive;
